import { useState } from 'react';
import { Employee } from "../../model/Employee";
import { formatDate, formatDateSQL } from '../index2';
import { Eye, Edit3, Trash2, EllipsisVertical } from 'lucide-react';

export let employees : Employee[] = [
];

const updateEmployeesData = (updatedData = []) => {
  employees.length = 0; // Clear the existing array
  updatedData.forEach((item: any) => {
    employees.push({
      id: item.id || '-',
      nama: item.nama || '-',
      nik: item.no_kary || '-',
      level: item.level || 'user',
      jabatan: item.jabatan || 'Staf',
      nohp: item.no_hp || '-'
    });
  });
} 

export const getStatusBadge = (status: string) => {
    if (status === 'organic') {
        return (
            <span className="px-3 py-1 text-xs font-semibold bg-green-100 text-green-800 rounded-full">
                Karyawan Tetap
            </span>
        );
    }
    return (
      <span className="px-3 py-1 text-xs font-semibold bg-blue-100 text-blue-800 rounded-full">
        Kontrak
      </span>
    );
};

export const fetchGetKaryawanAll = async () =>{
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/bawaslu_phwt/pegawai/all");
  const result = await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { updateEmployeesData(result.data ?? []); return { "status" : result.status, "message" : result.message, data: employees }; })
    .catch((error : any) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message , data: []} });
  return result;
}

export const fetchPostKaryawan = async ({ karyawan } : { karyawan : any}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(karyawan),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/karyawan");
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchPutKaryawan = async ({ id , karyawan } : { id : string; karyawan : any}) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: JSON.stringify(karyawan),
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/karyawan/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const fetchDeleteKaryawan = async (id : string) => {
  let key = process.env.REACT_APP_API_KEY || '';
  const myHeaders = new Headers();
  myHeaders.append("Authorization", key);

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers: myHeaders,
    redirect: "follow" as RequestRedirect
  };

  const apiUrl = (process.env.REACT_APP_API_URL + "/karyawan/" + id);
  return await fetch(apiUrl, requestOptions)
    .then((response) => response.json())
    .then((result) => { return { "status" : result.status, "message" : result.message }; })
    .catch((error) => { return { "status" : 500, "message" : "Terjadi kesalahan pada server", "error" : error.message } });
}

export const RenderTableKaryawan = ({ filteredData, onOpenDetail, onOpenEdit, onRemoveState }: { 
    filteredData: Employee[] | null; 
    onOpenDetail : (employee: Employee) => void;
    onOpenEdit : (employee: Employee) => void;
    onRemoveState : () => void;
}) => (
  <>
    {
      filteredData && filteredData.length > 0 ? (
        filteredData.map((karyawan, idx) => (
          <tr key={idx} className="hover:bg-gray-50 transition-colors">
            <td className="px-6 py-4 whitespace-nowrap">
              <div>
                <div className="text-sm font-medium text-gray-900">{karyawan.nama}</div>
                {/* <div className="text-sm text-gray-500">{karyawan.position}</div> */}
              </div>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {karyawan.nik}
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
              { karyawan.jabatan }
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-center">
              <div className="flex justify-center items-center space-x-2">
                <button onClick={() => onOpenDetail(karyawan)} className="text-blue-600 hover:text-blue-900 p-1 rounded">
                  <Eye className="w-4 h-4" />
                </button>
                <button onClick={() => onOpenEdit(karyawan)} className="text-green-600 hover:text-green-900 p-1 rounded">
                  <Edit3 className="w-4 h-4" />
                </button>
                <button 
                  onClick={ async () => { try{ if (window.confirm(`Yakin hapus ${karyawan.nama}?`)) { await fetchDeleteKaryawan(karyawan?.id.toString()); } onRemoveState() } catch (err) { console.error("Gagal hapus:", err); } }} 
                  className="text-red-600 hover:text-red-900 p-1 rounded">
                  <Trash2 className="w-4 h-4" />
                </button>
                {/* <button onClick={() => {}} className="text-green-600 hover:text-green-900 p-1 rounded">
                  <EllipsisVertical className="w-4 h-4" />
                </button> */}
              </div>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={18} className="text-center py-4 text-gray-500">
            Tidak ada data
          </td>
        </tr>
      )
    }
  </>
);

export const DetailEmployeeModal = ({ employeeDetail, stateShowModal } : { 
  employeeDetail : Employee | null,
  stateShowModal : (show: boolean) => void | false
}) =>(
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-semibold text-gray-800">Detail Karyawan : {employeeDetail?.nama} </h3>
        <button
          onClick={() => stateShowModal(false)}
          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
        >
          ✕
        </button>
      </div>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nama Lengkap
          </label>
          <label>
            { employeeDetail?.nama }
          </label>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            NIK
          </label>
          <label>
            { employeeDetail?.nik }
          </label>
        </div>
      </div>

    </div>
  </div>
);

export const AddEmployeeModal = ({ setShowAddModal, onPostState } : {
    setShowAddModal : (show: boolean) => void | false; 
    onPostState     : () => void 
  }) => {
  
  const [formData, setFormData] = useState<Employee>({
    id: "",
    nama: "",
    nik: "",
    level: "",
    jabatan: "",
    nohp: ""
  });

  
  const [errors, setErrors] = useState<{ [key: string]: string }>({});


  if (!formData) return null; // safety
  // fungsi validasi
  const validate = () => {
    const newErrors: { [key: string]: string } = {};
    const NIK_digit = 8;

    if (!formData.nama.trim()) newErrors.name = "Nama wajib diisi";
    if (formData.nik.length < NIK_digit)
      newErrors.nik = `NIK harus ${NIK_digit} digit angka`;
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // true kalau tidak ada error
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    await fetchPostKaryawan({ karyawan: formData });
    setShowAddModal(false);
    onPostState();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-semibold text-gray-800">Tambah Karyawan Baru</h3>
            <button
              onClick={() => setShowAddModal(false)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              ✕
            </button>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nama Lengkap
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Masukkan nama lengkap"
                value={formData.nama ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    nama: e.target.value,
                  })
                }
              />
              {errors.name && (
                <p className="text-sm text-red-500 mt-1">{errors.name}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                NIK
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Masukkan Nomor Induk Karyawan"
                value={formData.nik ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    nik: e.target.value,
                  })
                }
              />
              {errors.nik && (
                <p className="text-sm text-red-500 mt-1">{errors.nik}</p>
              )}
            </div>
            
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Status Karyawan
              </label>
              <select 
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={formData?.status || "-"}
                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              >
                <option value="-" disabled>Pilih Status</option>
                <option value="organic" selected>Karyawan Tetap</option>
                <option value="kontrak">Kontrak</option>
              </select>
              {errors.status && (
                <p className="text-sm text-red-500 mt-1">{errors.status}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tanggal Masuk
              </label>
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={formatDateSQL(formData?.joinDate || '') ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    joinDate: e.target.value,
                  })
                }
              />
              {errors.joinDate && (
                <p className="text-sm text-red-500 mt-1">{errors.joinDate}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tahun Kontrak (untuk karyawan kontrak)
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder={formData?.contractYear?.toString() ?? "-"}
                disabled={formData.status === 'organic'}
                value={formData?.contractYear ?? Number(0)}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contractYear: Number(e.target.value),
                  })
                }
              />
              <label className="block text-sm font-medium text-gray-500 mb-2">Jika ingin mengosongkan isi angka 0</label>
              {errors.contractYear && (
                <p className="text-sm text-red-500 mt-1">
                  {errors.contractYear}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Divisi Kontrak (untuk karyawan kontrak)
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder={formData?.contractDivisi}
                disabled={formData.status === 'organic'}
                value={formData?.contractDivisi === '-' ? "" : formData.contractDivisi}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contractDivisi: e.target.value,
                  })
                }
              />
              {errors.contractDivisi && (
                <p className="text-sm text-red-500 mt-1">{errors.contractDivisi}</p>
              )}
            </div> */}
            
            <div className="flex space-x-3 pt-4">
              <button
                onClick={() => setShowAddModal(false)}
                className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              >
                Batal
              </button>
              <button
                onClick={handleSubmit}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Simpan
              </button>
            </div>
          </div>
    
        </div>
    </div>
  )
};

export const EditEmployeeModal = ({ employeeDetail, stateShowModal, onEditState} : { 
  employeeDetail : Employee | null,
  stateShowModal : (show: boolean) => void | false,
  onEditState    : () => void
}) => {
  const [formData, setFormData] = useState<Employee | null>(employeeDetail);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});


  if (!formData) return null; // safety
  // formData.contractYear = isNaN(Number(formData.contractYear)) ? 0 : Number(formData.contractYear);
  
  // fungsi validasi
  const validate = () => {
    const newErrors: { [key: string]: string } = {};
    // const NIK_digit = 8;

    // if (!formData.name.trim()) newErrors.name = "Nama wajib diisi";
    // if (formData.nik.length < NIK_digit)
    //   newErrors.nik = `NIK harus ${NIK_digit} digit angka`;
    // if (!formData.status) newErrors.status = "Pilih status karyawan";
    // if (!formData.joinDate) newErrors.joinDate = "Tanggal Masuk harus diisi";
    // if (formData.status === "kontrak" && (!formData.contractYear || formData.contractYear === 0))
    //   newErrors.contractYear = "Tahun kontrak harus diisi";
    // if (formData.status === "kontrak" && (!formData.contractDivisi || formData.contractDivisi === '-'))
    //   newErrors.contractDivisi = "Divisi kontrak harus diisi";
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // true kalau tidak ada error
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    await fetchPutKaryawan({id : formData.id, karyawan : formData }); 
    stateShowModal(false); 
    onEditState();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-semibold text-gray-800">Tambah Karyawan Baru</h3>
            <button
              onClick={() => stateShowModal(false)}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              ✕
            </button>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Nama Lengkap
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Masukkan nama lengkap"
                value={formData.nama ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    nama: e.target.value,
                  })
                }
              />
              {errors.name && (
                <p className="text-sm text-red-500 mt-1">{errors.name}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                NIK
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Masukkan Nomor Induk Karyawan"
                value={formData.nik ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    nik: e.target.value,
                  })
                }
              />
              {errors.nik && (
                <p className="text-sm text-red-500 mt-1">{errors.nik}</p>
              )}
            </div>
            
            {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Status Karyawan
              </label>
              <select 
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={formData?.status || "-"}
                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              >
                <option value="-" disabled>Pilih Status</option>
                <option value="organic" selected>Karyawan Tetap</option>
                <option value="kontrak">Kontrak</option>
              </select>
              {errors.status && (
                <p className="text-sm text-red-500 mt-1">{errors.status}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tanggal Masuk
              </label>
              <input
                type="date"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                value={formatDateSQL(formData?.joinDate || '') ?? ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    joinDate: e.target.value,
                  })
                }
              />
              {errors.joinDate && (
                <p className="text-sm text-red-500 mt-1">{errors.joinDate}</p>
              )}
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Tahun Kontrak (untuk karyawan kontrak)
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder={formData?.contractYear?.toString() ?? "-"}
                disabled={formData.status === 'organic'}
                value={formData?.contractYear ?? Number(0)}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contractYear: Number(e.target.value),
                  })
                }
              />
              <label className="block text-sm font-medium text-gray-500 mb-2">Jika ingin mengosongkan isi angka 0</label>
              {errors.contractYear && (
                <p className="text-sm text-red-500 mt-1">
                  {errors.contractYear}
                </p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Divisi Kontrak (untuk karyawan kontrak)
              </label>
              <input
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder={formData?.contractDivisi === '-' ? "Tidak dalam kontrak" : formData.contractDivisi}
                disabled={formData.status === 'organic'}
                value={formData?.contractDivisi === '-' ? "" : formData.contractDivisi}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contractDivisi: e.target.value,
                  })
                }
              />
              {errors.contractDivisi && (
                <p className="text-sm text-red-500 mt-1">{errors.contractDivisi}</p>
              )}
            </div> */}
            
            <div className="flex space-x-3 pt-4">
              <button
                onClick={() => stateShowModal(false)}
                className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              >
                Batal
              </button>
              <button
                onClick={handleSubmit}
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Simpan
              </button>
            </div>
          </div>
    
        </div>
    </div>
  )
}
